import React from 'react';
import { HourglassIcon, TimerIcon } from 'lucide-react';
type ProblemCardProps = {
  variant: 'blue' | 'gold' | 'navy';
  title: string;
  paragraphs: string[];
  highlight: string;
};
const styles = {
  blue: {
    card: 'border border-slate-200 border-l-[5px] border-l-sky-500 bg-white',
    title: 'text-blue-950',
    body: 'text-slate-600',
    q: 'text-blue-950',
    hl: 'text-sky-600',
    icon: 'text-amber-500'
  },
  gold: {
    card: 'border border-slate-200 border-l-[5px] border-l-amber-400 bg-white',
    title: 'text-blue-950',
    body: 'text-slate-600',
    q: 'text-blue-950',
    hl: 'text-amber-700',
    icon: 'text-amber-500'
  },
  navy: {
    card: 'bg-blue-950',
    title: 'text-white',
    body: 'text-slate-200',
    q: 'text-amber-400',
    hl: 'text-amber-400',
    icon: 'text-amber-400'
  }
};
export function ProblemCard({
  variant,
  title,
  paragraphs,
  highlight
}: ProblemCardProps) {
  const s = styles[variant];
  const Icon = variant === 'gold' ? HourglassIcon : variant === 'navy' ? TimerIcon : null;
  return <article className={`rounded-md px-4 py-4 md:px-5 ${s.card}`} data-id="element-132" data-mp="1dufh7c8qcw8v">
      <h2 className={`text-lg font-extrabold uppercase leading-tight tracking-tight md:text-2xl ${s.title}`} data-id="element-133" data-mp="1dvqlrea02811">
        {Icon && <Icon className={`mr-2 inline h-5 w-5 -translate-y-0.5 md:h-6 md:w-6 ${s.icon}`} strokeWidth={2.5} aria-hidden data-id="element-134" data-mp="191w2gbyb3v2h" />}
        {title}
      </h2>
      <div className="mt-2 space-y-1.5 text-sm leading-snug md:text-base" data-id="element-135" data-mp="1043ll3cxsfcz">
        {paragraphs.map(p => p.startsWith('¿') ? <p key={p} className={`font-bold ${s.q}`} data-id="element-136" data-mp="1wr74rxvb1xiq">
              {p}
            </p> : <p key={p} className={s.body} data-id="element-137" data-mp="1spvgbvo63ic4">
              {p}
            </p>)}
      </div>
      <p className={`mt-2.5 text-xs font-extrabold uppercase leading-tight md:text-sm ${s.hl}`} data-id="element-138" data-mp="1itilgugvyyfs">{highlight}</p>
    </article>;
}